import { render, staticRenderFns } from "./Coaching.vue?vue&type=template&id=05ad9f1d&scoped=true"
import script from "./Coaching.vue?vue&type=script&lang=js"
export * from "./Coaching.vue?vue&type=script&lang=js"
import style0 from "./Coaching.vue?vue&type=style&index=0&id=05ad9f1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ad9f1d",
  null
  
)

export default component.exports